<template>
    <div class="row mt-4 thresholdSlider">
        <div class="col-12">
            <h6>{{title}}</h6>
        </div>
        <el-col class="col-12" v-loading="loading">
            <div class="">
                <span class="position-relative smooth-transition"
                      :style="'left:' + danger1Width + '%; margin-left:-4px'">A</span>
                <span class="position-relative smooth-transition"
                      :style="'left:' + sum([danger1Width,alert1Width]) + '%; margin-left:-6px'">B</span>
                <span class="position-relative smooth-transition"
                      :style="'left:' +sum([danger1Width,alert1Width,ok1Width])+ '%; margin-left:-10px'">C</span>
                <span class="position-relative smooth-transition"
                      :style="'left:' + sum([danger1Width,alert1Width,ok1Width,alert2Width]) + '%; margin-left:-8px'">D</span>
            </div>{{$t('INDICATOR.WARN')}}       <div class="progress progress--thick">
                <div
                        class="progress-bar bg-danger progress--thick"
                        role="progressbar"
                        :style="'width:' + danger1Width + '%'"
                        aria-valuenow="15"
                        aria-valuemin="0"
                        aria-valuemax="100"
                >
                    <span>{{$t('INDICATOR.DANGER')}}</span>
                </div>
                <div
                        class="progress-bar bg-warning progress--thick"
                        role="progressbar"
                        :style="'width:' + alert1Width + '%'"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                >
                    <span>{{$t('INDICATOR.WARN')}}</span>
                </div>
                <div
                        class="progress-bar bg-success progress--thick"
                        role="progressbar"
                        :style="'width:' + ok1Width + '%'"
                        aria-valuenow="20"
                        aria-valuemin="0"
                        aria-valuemax="100"
                >
                    <span>{{$t('INDICATOR.OK')}}</span>
                </div>
                <div
                        class="progress-bar bg-warning progress--thick"
                        role="progressbar"
                        :style="'width:' + alert2Width + '%'"
                        aria-valuenow="20"
                        aria-valuemin="0"
                        aria-valuemax="100"
                >
                    <span>{{$t('INDICATOR.WARN')}}</span>
                </div>
                <div
                        class="progress-bar bg-danger progress--thick"
                        role="progressbar"
                        :style="'width:' + danger2Width + '%'"
                        aria-valuenow="20"
                        aria-valuemin="0"
                        aria-valuemax="100"
                >
                    <span>{{$t('INDICATOR.DANGER')}}</span>
                </div>
            </div>
            <div class="d-none d-md-block">
                <div class="bubble mybubble smooth-transition "
                     :style="'left:'+danger1Width+'%;' + bubbleMarginLeft('A')">
                    <label class="d-flex justify-content-center align-items-center">
                        <input type="number"
                               :step="step"
                               class="wiagro_configs--inputBubble"
                               :value="A"
                               @input="debounceA"

                        />
                        <span>{{unit}}</span>
                    </label>
                </div>

                <div class="bubble mybubble smooth-transition"

                     :style="'left:'+sum([danger1Width,alert1Width])+'%;' + bubbleMarginLeft('B')">
                    <label class="d-flex justify-content-center align-items-center">
                        <input type="number" :step="step" class="wiagro_configs--inputBubble" :value="B"
                               @input="debounceB"

                        />
                        <span>{{unit}}</span>
                    </label>
                </div>
                <div class="bubble mybubble smooth-transition"
                     :style="'left:'+sum([danger1Width,alert1Width,ok1Width])+'%;' + bubbleMarginLeft('C')">
                    <label class="d-flex justify-content-center align-items-center">
                        <input type="number" :step="step" class="wiagro_configs--inputBubble" :value="C"
                               @input="debounceC"
                        />
                        <span>{{unit}}</span>
                    </label>
                </div>
                <div class="bubble mybubble smooth-transition"
                     :style="'left:'+sum([danger1Width,alert1Width,ok1Width,alert2Width])+'%; ' + bubbleMarginLeft('D')">
                    <label class="d-flex justify-content-center align-items-center">
                        <input type="number" :step="step" class="wiagro_configs--inputBubble" :value="D"
                               @input="debounceD"
                        />
                        <span>{{unit}}</span>
                    </label>
                </div>
            </div>

            <div class="row align-items-center mt-5 mb-4 d-block d-md-none">
                <div class="col-12 col-md-3 text-center mb-3 text-center mb-3">
                    <span class="wiagro_configs--specialInput">A</span>
                    <el-input-number controls-position="right"
                                     :value="A"
                                     @input="debounceA"
                    />
                </div>
                <div class="col-12 col-md-3 text-center mb-3 text-center mb-3">
                    <span class="wiagro_configs--specialInput">B</span>
                    <el-input-number :value="B"
                                     @input="debounceB" controls-position="right"

                    />
                </div>
                <div class="col-12 col-md-3 text-center mb-3">
                    <span class="wiagro_configs--specialInput">C</span>
                    <el-input-number :value="C"
                                     @input="debounceC" controls-position="right"

                    />
                </div>
                <div class="col-12 col-md-3 text-center mb-3">
                    <span class="wiagro_configs--specialInput">D</span>
                    <el-input-number :value="D"
                                     @input="debounceD" controls-position="right"

                    />
                </div>
            </div>
        </el-col>
    </div>
</template>

<script>
    import api from "../../utils/api/api";
    import unitConverter from "../../utils/unitConverter";
    import debounce from "lodash/debounce.js";

    export default {
        name: "thresholdSliders",
        props: {
            type: {
                type: String,
                required: true,
                validator: function (val) {
                    return ["temp", "hum", "co2", "moisture"].indexOf(val.toLowerCase()) !== -1;
                }
            },
            title: {
                required: false,
                type: String
            },
            grain: {
                required: true,
                type: String
            },
            onThresholdChange: {
                required: false,
                type: Function
            }
        },
        data: function () {
            return {
                A: undefined,
                B: undefined,
                C: undefined,
                D: undefined,
                max: undefined,
                min: undefined,

                loading: true,
            }
        },
        mounted: function () {
            this.loading = true;
            api.getGrainAlertThresholds(this.grain).then(value => {
                this.A = unitConverter.convertTo(this.type, value.limits[this.type].status[2].min_end, this.$store.getters.unit(this.type));
                this.B = unitConverter.convertTo(this.type, value.limits[this.type].status[0].min_start, this.$store.getters.unit(this.type));
                this.C = unitConverter.convertTo(this.type, value.limits[this.type].status[0].max_end, this.$store.getters.unit(this.type));
                this.D = unitConverter.convertTo(this.type, value.limits[this.type].status[2].max_start, this.$store.getters.unit(this.type));
                this.max = unitConverter.convertTo(this.type, value.limits[this.type].status[2].max_end, this.$store.getters.unit(this.type));
                this.min = unitConverter.convertTo(this.type, value.limits[this.type].status[2].min_start, this.$store.getters.unit(this.type));
                this.loading = false;
            });
        },
        watch: {
            A: function (newVal, oldVal) {
                if (newVal < this.min) {
                    this.A = this.min;
                }
                if (this.B < newVal) {
                    this.A = oldVal;
                }
                this.updateResult();
            },
            B: function (newVal, oldVal) {
                if (newVal < this.A) {
                    this.B = oldVal;
                }
                if (this.C < newVal) {
                    this.B = oldVal;
                }
                this.updateResult();
            },
            C: function (newVal, oldVal) {
                if (newVal < this.B) {
                    this.C = oldVal;
                }
                if (this.D < newVal) {
                    this.C = oldVal;
                }
                this.updateResult();
            },
            D: function (newVal, oldVal) {
                if (newVal < this.C) {
                    this.D = oldVal;
                }
                if (this.max < newVal) {
                    this.D = oldVal;
                }
                this.updateResult();
            },
        },
        computed: {
            unit: function () {
                return this.$store.getters.unit(this.type);
            },

            step: function () {
                if (this.type === "co2" && this.unit === "ppm") {
                    return 100;
                } else {
                    return 0.5
                }
            },
            danger1Width: function () {
                return 100 * (this.A - this.min) / (this.max - this.min)
            },
            alert1Width: function () {
                return 100 * (this.B - this.A) / (this.max - this.min);
            },
            ok1Width: function () {
                return 100 * (this.C - this.B) / (this.max - this.min);
            },
            alert2Width: function () {
                return 100 * (this.D - this.C) / (this.max - this.min);
            },
            danger2Width: function () {
                return 100 * (this.max - this.D) / (this.max - this.min);
            },
            thresholdResult() {
                return {
                    A: Number.parseFloat(this.A),
                    B: Number.parseFloat(this.B),
                    C: Number.parseFloat(this.C),
                    D: Number.parseFloat(this.D),
                    min: Number.parseFloat(this.min),
                    max: Number.parseFloat(this.max)
                }
            },
        },
        methods: {
            sum: function (array) {
                return array.reduce((a, b) => a + b, 0)
            },
            bubbleMarginLeft(thresholdLetter) {
                if (this.type === "co2" && this.unit === "ppm") {
                    if (thresholdLetter === "A") {
                        return "width: 80px !important; margin-left: -40px";
                    } else {
                        return "width: 80px !important; margin-left: -80px";
                    }
                } else {
                    if (thresholdLetter === "A") {
                        return "width: 60px !important; margin-left: -30px";
                    } else {
                        return "width: 60px !important; margin-left: -60px";
                    }
                }
            },
            debounceA: debounce(function (e) {
                if (e && e.target && e.target.value) {
                    this.A = Number.parseFloat(Number.parseFloat(e.target.value).toFixed(1));
                }
            }, 300),
            debounceB: debounce(function (e) {
                if (e && e.target && e.target.value) {
                    this.B = Number.parseFloat(Number.parseFloat(e.target.value).toFixed(1));
                }
            }, 300),
            debounceC: debounce(function (e) {
                if (e && e.target && e.target.value) {
                    this.C = Number.parseFloat(Number.parseFloat(e.target.value).toFixed(1));
                }
            }, 300),
            debounceD: debounce(function (e) {
                if (e && e.target && e.target.value) {
                    this.D = Number.parseFloat(Number.parseFloat(e.target.value).toFixed(1));
                }
            }, 300),
            updateResult() {
                if (this.onThresholdChange !== undefined) {
                    this.onThresholdChange(this.grain, this.type, this.thresholdResult);
                }
            }

        }

    }
</script>

<style lang="scss">
    .thresholdSlider {

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            /* display: none; <- Crashes Chrome on hover */
            -webkit-appearance: none;
            margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
        }

        input[type=number] {
            -moz-appearance: textfield; /* Firefox */
        }

        input:focus {
            outline: none;
        }

        .progress {
            border-radius: 0.25rem !important;

            &--thick {
                height: 20px;
                opacity: 0.9;
            }
        }

        .smooth-transition {
            transition: left 0.6s ease;
        }

        .mybubble {

            width: 7% !important;
            display: inline-block;
            align-items: center;
            font-size: 1em !important;
            margin-top: 1em;

        }

        .bubble {
            position: relative;
            width: 75px;
            height: 30px;
            padding: 2px;
            background: #ffffff;
            -webkit-border-radius: 75px;
            -moz-border-radius: 75px;
            border-radius: 5px;
            border: #e8e9ec solid 2px;

            &::after {
                content: "";
                position: absolute;
                border-style: solid;
                border-width: 0 9px 12px;
                border-color: #ffffff transparent;
                display: block;
                width: 0;
                z-index: 1;
                margin-left: -9px;
                top: -12px;
                left: 50%;
            }

            &::before {

                content: "";
                position: absolute;
                border-style: solid;
                border-width: 0 10px 13px;
                border-color: #e8e9ec transparent;
                display: block;
                width: 0;
                z-index: 0;
                margin-left: -10px;
                top: -15px;
                left: 50%;
            }

            &:focus-within {
                border-color: #6bc9d777;
                z-index: 200;

                &::before {
                    content: "";
                    position: absolute;
                    border-style: solid;
                    border-width: 0 10px 13px;
                    border-color: #6bc9d777 transparent;
                    display: block;
                    width: 0;
                    z-index: 0;
                    margin-left: -10px;
                    top: -15px;
                    left: 50%;
                }

                &::after {
                    content: "";
                    position: absolute;
                    border-style: solid;
                    border-width: 0 9px 12px;
                    border-color: #fff transparent;
                    display: block;
                    width: 0;
                    z-index: 1;
                    margin-left: -9px;
                    top: -12px;
                    left: 50%;
                }
            }
        }
    }
</style>